<template>
  <q-layout view="hHh LpR fFf">
  <!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
    <router-link to="/object-manage">Object</router-link>
  </div> -->
  <!-- header -->
    <q-header elevated class="header bg-white" v-if="this.$route.path != '/'">
      <q-toolbar>
        <img src="./assets/logo_bw.png">
        <!-- <div class="text-h5 text-bold" style="color:#0a7eb8;font-family:monospace">OMS</div> -->
        <!-- <q-btn flat @click="drawer = !drawer" round dense icon="menu" style="box-shadow:none;margin:0px;color:#3e47cc" /> -->
        <q-toolbar-title></q-toolbar-title>
        <!-- 顯示 使用者帳號_使用者名稱_角色 -->
          <div class="text-subtitle1 text-bold text-primary">歡迎，{{$store.getters.getUserInfo.userName}}</div>
          <a class="link_mission q-ml-md q-mr-md" @click="changePassword()">變更密碼</a>
          <a class="link_mission" @click="openManual()" target="view_window">操作手冊</a>
          <a class="link_mission q-ml-md" @click="logout()">登出</a>
      </q-toolbar>
    </q-header>
    <!-- drawer -->
    <!-- <q-drawer
        v-model="drawer"
        show-if-above
        :width="200"
        :breakpoint="500"
        bordered
        content-class="bg-blue"
      >
        <q-scroll-area class="fit">
          <q-list v-for="(menuItem, index) in menuList" :key="index">

            <q-item clickable :active="menuItem.label === 'Outbox'" v-ripple>
              <q-item-section avatar>
                <q-icon :name="menuItem.icon" />
              </q-item-section>
              <q-item-section>
                {{ menuItem.label }}
              </q-item-section>
            </q-item>

          <q-separator v-if="menuItem.separator" />

          </q-list>
        </q-scroll-area>
      </q-drawer> -->
    <!-- pages -->
    <q-page-container :style="$router.currentRoute.path !== '/' ? 'padding-top: 1.7em!important;background-color:#fff;' : ''">
      <router-view/>
    </q-page-container>
    <!-- footer -->
    <q-footer class="bg-grey-5">
      <q-toolbar style="min-height:30px">
        <q-toolbar-title class="footer text-center" style="font-size:1em">COPYRIGHT © 2019 YKK AP Inc. ALL RIGHTS RESERVED.</q-toolbar-title>
      </q-toolbar>
    </q-footer>
  </q-layout>
</template>

<script>
import { commonMixin } from '@/common/js/mixins'
// const menuList = [
//   {
//     icon: 'inbox',
//     label: 'Inbox',
//     separator: true
//   },
//   {
//     icon: 'send',
//     label: 'Outbox',
//     separator: false
//   },
//   {
//     icon: 'delete',
//     label: 'Trash',
//     separator: false
//   }
// ]
export default {
  name: 'App',
  mixins: [commonMixin],
  data () {
    return {
      // drawer: false,
      // menuList
    }
  },
  created () {
    if (this.$store.getters.isLogin) {
      // 已登入時 設定 登入帳號與顯示名稱
      this.$store.commit('initUserInfo')
      // 設定 當前選擇角色
      this.$store.commit('setCurrentUserRole')
      // 設定 JwtToken
      this.$http.api.defaults.headers.common['Authorization'] = localStorage.getItem('token')
    } else {
      this.$router.push('/')
    }
  },
  mounted () {
    console.log('$route', this.$route)
    // if (localStorage.getItem('fullUserInfo') !== null) this.$store.commit('setCurrentUserRole')
    // if (localStorage.getItem('token') !== null) {
    //   this.$http.api.defaults.headers.common['Authorization'] = localStorage.getItem('token')
    // }
  },
  methods: {
    changePassword () {
      this.$router.push('/change-password')
    },
    openManual () {
      window.open('https://oms.ykkap.com.tw/docu/oms/', '操作手冊')
      // window.location = 'https://oms.ykkap.com.tw/docu/oms/'
    },
    logout () {
      this.$store.commit('logout')
      this.$router.push('/')
    }
  }
}
</script>
<style>
/* Note:a:hover MUST come after a:link and a:visited in the CSS definition in order to be effective.
 a:active MUST come after a:hover in the CSS definition in order to be effective. */
  a.link_mission  {
    text-decoration:none;
    color:#0a7eb8 !important;
  }
  a:link.link_mission  {
    text-decoration:none;
  }
  a:visited.link_mission  {
    text-decoration:none;
    color:#0a7eb8;
  }
  a:hover.link_mission {
    /* 當滑鼠經過超連結時，超連結往右下位移1像素且為桃紅色*/
    position: relative;
    top: 1px;
    left: 1px;
    color: #ff007a !important;
    text-decoration:underline;
  }
.q-page-container {
  padding: 0px !important
  /* padding-bottom: 0.3em!important; */
}
</style>
